// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__cDAmO","label":"CategoryService_label__2Sp6l","location":"CategoryService_location__2OUhE"};